import { postJson } from '@/shared/api/apiClient';

export type FeedbackResult = {
  id: string;
  createdAt: string;
};

type FeedbackApiResponse = {
  id: string;
  created_at: string;
};

// Attribution (which account this came from) is handled server-side from the
// auth token — postJson attaches it automatically — so the caller only ever
// sends the message itself (and, optionally, which job it's about).
export async function submitFeedback(message: string, jobId?: string): Promise<FeedbackResult> {
  const response = await postJson<FeedbackApiResponse>('/api/v1/feedback', {
    message,
    ...(jobId ? { job_id: jobId } : {}),
  });
  return { id: response.id, createdAt: response.created_at };
}
